import { render, staticRenderFns } from "./MemberProfile.vue?vue&type=template&id=7fad24e4&lang=pug"
var script = {}
import style0 from "./MemberProfile.vue?vue&type=style&index=0&id=7fad24e4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports